<template>
    <div :class="avatarClass" :title="avatarTitle" @click="goToUserProfile">
        <template v-if="!isImageBroken && userAvatar">
            <img :src="userAvatar" @error="handleImageError" />
        </template>
        <span v-else>
            <svg viewBox="0 0 100 100" width="100" height="100" xmlns="http://www.w3.org/2000/svg">
                <text
                    x="51%"
                    y="53%"
                    font-size="33"
                    font-weight="400"
                    alignment-baseline="middle"
                    dominant-baseline="middle"
                    text-anchor="middle"
                >
                    {{ initials }}
                </text>
            </svg>
        </span>
    </div>
</template>

<script>
    export default {
        props: {
            size: { type: String, required: true },
            type: { type: String, default: 'primary' },
            user: { type: Object, default: undefined },
            isCurrent: { type: Boolean, default: undefined },
            isUserProfileLinkEnabled: { type: Boolean, default: true },
            hoverAnimation: { type: Boolean, default: false },
        },
        data() {
            return {
                isImageBroken: false,
            }
        },
        computed: {
            avatarClass() {
                return {
                    avatar: true,
                    [`avatar--size-${this.size}`]: true,
                    [`avatar--type-initials--type-${this.type}`]: true,
                    'avatar--type-image': this.userAvatar && !this.isImageBroken,
                    'avatar--type-initials': !this.userAvatar || this.isImageBroken,
                    'avatar--is-current': this.isCurrent,
                    'avatar--is-clickable': this.isUserProfileLinkEnabled,
                    'avatar--hover': this.hoverAnimation,
                }
            },

            initials() {
                if (this.isUser()) return this.initialsFromUser()
                else if (this.isConnection()) return this.initialsFromConnection()
                else if (this.isBasicUser()) return this.initialsFromBasicUser()
                else return ''
            },

            avatarTitle() {
                return this.isUserProfileLinkEnabled ? this.$t('pages.profile.preview.tooltip') : ''
            },

            userAvatar() {
                const user = this.user || {}
                return user.avatar?.['thumb-360'] || user.profilePicture?.['thumb-360'] || user.image?.['thumb-360'] || null
            },
        },

        methods: {
            handleImageError() {
                this.isImageBroken = true
            },
            isUser() {
                return this.user?.firstName
            },
            isConnection() {
                return this.user?.target && this.user?.name
            },
            isBasicUser() {
                return !this.isUser() && !this.isConnection() && this.user?.name
            },
            initialsFromUser() {
                return this.user?.firstName[0] + ' ' + this.user?.lastName[0]
            },
            initialsFromConnection() {
                let conn = this.user

                if (conn.connectionType === 0) {
                    let [firstName, lastName] = conn.name.split(' ')

                    if (firstName && firstName.length > 0 && lastName && lastName.length > 0) {
                        return firstName[0] + ' ' + lastName[0]
                    }
                } else if (conn.connectionType === 1) {
                    let [userName, domain] = conn.name.split('@')

                    if (conn.practiceType == 2 && userName && userName.length > 0) {
                        return userName.toUpperCase()[0]
                    } else if (domain && domain.length > 0) {
                        return domain.toUpperCase()[0]
                    }
                } else return ''
            },
            initialsFromBasicUser() {
                return this.user.name
                    .split(' ', 2)
                    .filter((s) => !!s)
                    .map((s) => s[0])
                    .join(' ')
            },
            goToUserProfile() {
                if (this.isUserProfileLinkEnabled && this.isUserPhysician()) {
                    this.$router.push({ name: 'profile.user', params: { id: this.user.id } })
                }
            },
            isUserPhysician() {
                return this.user.specialities && this.user.specialities[0] && this.user.specialities[0].subSpeciality
            },
        },
    }
</script>
